export default function renderDuration (from, to) {
  let nights
  if (typeof from === 'number') {
    nights = from
  } else {
    nights = from.differenceInDays(to)
  }
  return nights ? `${nights + 1} days, ${nights} nights` : '1 day'
}
